import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { Logo } from './Logo';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPolicyOpen, setIsPolicyOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="flex justify-between items-center py-4" data-id="element-119">
          <Link to="/" className="flex items-center" data-id="element-120">
            <Logo size="md" data-id="element-121" />
          </Link>
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-122">
            <Link to="/" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-123">
              Home
            </Link>
            <Link to="/about" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-124">
              About Us
            </Link>
            <Link to="/repair-services" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-125">
              Repair Services
            </Link>
            <Link to="/faq" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-126">
              FAQs
            </Link>
            <div className="relative" data-id="element-127">
              <button onMouseEnter={() => setIsPolicyOpen(true)} onMouseLeave={() => setIsPolicyOpen(false)} className="flex items-center space-x-1 text-slate-600 hover:text-blue-600 transition-colors" data-id="element-128">
                <span data-id="element-129">Policies</span>
                <ChevronDown className="w-4 h-4" data-id="element-130" />
              </button>
              {isPolicyOpen && <div onMouseEnter={() => setIsPolicyOpen(true)} onMouseLeave={() => setIsPolicyOpen(false)} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg py-2 z-50" data-id="element-131">
                  <Link to="/terms-of-service" className="block px-4 py-2 text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-132">
                    Terms & Conditions
                  </Link>
                  <Link to="/cancellation" className="block px-4 py-2 text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-133">
                    Cancellation Policy
                  </Link>
                  <Link to="/refund" className="block px-4 py-2 text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-134">
                    Refund Policy
                  </Link>
                  <Link to="/privacy-policy" className="block px-4 py-2 text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-135">
                    Privacy & Cookie Policy
                  </Link>
                </div>}
            </div>
            <Link to="/contact" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-136">
              Contact
            </Link>
            <a href="tel:08000554969" className="flex items-center space-x-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors" data-id="element-137">
              <Phone className="w-4 h-4" data-id="element-138" />
              <span data-id="element-139">0800 055 4969</span>
            </a>
          </nav>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden text-slate-600" data-id="element-140">
            {isMenuOpen ? <X className="w-6 h-6" data-id="element-141" /> : <Menu className="w-6 h-6" data-id="element-142" />}
          </button>
        </div>
        {isMenuOpen && <div className="lg:hidden py-4 border-t border-slate-200" data-id="element-143">
            <nav className="flex flex-col space-y-4" data-id="element-144">
              <Link to="/" className="text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-145">
                Home
              </Link>
              <Link to="/about" className="text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-146">
                About Us
              </Link>
              <Link to="/repair-services" className="text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-147">
                Repair Services
              </Link>
              <Link to="/faq" className="text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-148">
                FAQs
              </Link>
              <div className="pl-4 space-y-2" data-id="element-149">
                <p className="text-sm font-semibold text-slate-500" data-id="element-150">Policies</p>
                <Link to="/terms-of-service" className="block text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-151">
                  Terms & Conditions
                </Link>
                <Link to="/cancellation" className="block text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-152">
                  Cancellation Policy
                </Link>
                <Link to="/refund" className="block text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-153">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-154">
                  Privacy & Cookie Policy
                </Link>
              </div>
              <Link to="/contact" className="text-slate-600 hover:text-blue-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-155">
                Contact
              </Link>
              <a href="tel:08000554969" className="flex items-center space-x-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors w-fit" data-id="element-156">
                <Phone className="w-4 h-4" data-id="element-157" />
                <span data-id="element-158">0800 055 4969</span>
              </a>
            </nav>
          </div>}
      </div>
    </header>;
};